<div class="users">
    <div class="users-header">
        <tools-button routerLink="/admin/users/new">
            Create New User
        </tools-button>
    </div>
    <tools-table [dataSource]="dataSource" [format]="tableFormat">
        <ng-template #custom let-row="data">
            @if (!row.showChildTemplate) {
                <div class="users-name-cell">
                    <span>
                        {{ row.data.firstName }} {{ row.data.lastName }}
                    </span>
                    @if (
                        row.data.email.toLowerCase() ===
                        currentUserEmail()?.toLowerCase()
                    ) {
                        <tools-badge [variant]="BadgeVariant.PILL_GREEN">
                            You
                        </tools-badge>
                    }
                </div>
            }
            @if (row.showChildTemplate === "edit-action") {
                <button
                    type="button"
                    class="users-edit-action"
                    [routerLink]="['/admin/users', row.data.username, 'edit']"
                >
                    <span class="icon-edit"></span>
                    Edit
                </button>
            }
        </ng-template>
    </tools-table>
</div>
